import type React from 'react';

import { StaffDrawer, StaffDrawerInfo, StaffDrawerLink, StaffDrawerSection } from '#src/app/shared/components/staff';

import { useDmResponseStaffDrawer } from './hooks/useDmResponseStaffDrawer';

export const DmResponseStaffDrawer: React.FC<EmptyProps> = () => {
	const {
		data: {
			responseId,
			dmId,
			dmPubliclyVisible,
			dmIsPerson,
			petitionId,
			petitionStatus,
			petitionPromotable,
			starterId,
			urls,
		},
	} = useDmResponseStaffDrawer();

	return (
		<StaffDrawer>
			<StaffDrawerSection title="Response">
				<StaffDrawerInfo label="Response ID" value={responseId} copyable />
				<StaffDrawerLink href={urls.petitionDmResponses}>Petition's DM responses</StaffDrawerLink>
				<StaffDrawerLink href={urls.allDmResponses}>All DM responses</StaffDrawerLink>
				<StaffDrawerLink href={urls.selfServiceResponses}>Self-service responses</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Decision maker">
				<StaffDrawerInfo label="DM ID" value={dmId} copyable />
				<StaffDrawerInfo label="Publicly visible" value={dmPubliclyVisible} />
				<StaffDrawerInfo label="Is person" value={dmIsPerson} />
				<StaffDrawerLink href={urls.dmAdmin}>DM admin</StaffDrawerLink>
				<StaffDrawerLink href={urls.dmEdit}>Edit DM</StaffDrawerLink>
				<StaffDrawerLink href={urls.dmAdminAccounts}>Admin accounts</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Petition">
				<StaffDrawerInfo label="Petition ID" value={petitionId} copyable />
				<StaffDrawerInfo label="Status" value={petitionStatus} />
				<StaffDrawerInfo label="Promotable" value={petitionPromotable} />
				<StaffDrawerLink href={urls.petitionAdmin}>Petition admin</StaffDrawerLink>
				<StaffDrawerLink href={urls.petitionDashboard}>Dashboard</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Starter">
				<StaffDrawerInfo label="User ID" value={starterId} copyable />
				<StaffDrawerLink href={urls.userAdmin}>User admin</StaffDrawerLink>
			</StaffDrawerSection>
		</StaffDrawer>
	);
};
